<template>
  <zm-button
      v-if='bookWithSpecialistLink'
      data-testid="checkout-button-475"
      :data-url='bookWithSpecialistLink'
      class='opc-succezz_book-specialist'
      type="secondary"
      size='lg'
      @click='handleBookWithSpecialist'>
    {{ $t('billing.pbx.book_specialist_button') }}
  </zm-button>
</template>
<script>
import { mapGetters } from 'vuex';
import { sendGAbizInfo } from '@/views/checkout/utils'
import { navigateParentWindowTo } from '@/utils/modal-utils';

export default {
  computed: {
    ...mapGetters(['successConfig']),
    bookWithSpecialistLink() {
      return this.successConfig.bookWithSpecialistLink;
    },
  },
  methods: {
    handleBookWithSpecialist() {
      // Send GA tracking info
      sendGAbizInfo(`purchase confirmation`, 'book with a specialist');
      // Open link in new tab
      if (this.$context.is.modal) {
        navigateParentWindowTo(this.bookWithSpecialistLink);
      } else {
        window.open(this.bookWithSpecialistLink, '_blank');
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.opc-succezz_book-specialist {
  &.zbo-button--secondary {
    border: 1px solid #0C5CFF;
    padding-bottom: 9px;
    padding-top: 9px;
  }

  :deep(i) {
    color: #0C5CFF;
  }

  :deep(.zbo-button__label) {
    color: #0C5CFF;
  }
}
</style>
